import { render, staticRenderFns } from "./translationalTeams.vue?vue&type=template&id=3ca9eae3&scoped=true&"
import script from "./translationalTeams.vue?vue&type=script&lang=js&"
export * from "./translationalTeams.vue?vue&type=script&lang=js&"
import style0 from "./translationalTeams.vue?vue&type=style&index=0&id=3ca9eae3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ca9eae3",
  null
  
)

export default component.exports